import { hasEngineScheduleDeploy } from '../utils/engineScheduleProjection'

export const SCHEDULE_SHAPE = {
  legacy: 'legacy',
  v3: 'v3',
}

/** @returns {'legacy'|'v3'} */
export const classifyScheduleEntry = schedule => {
  if (hasEngineScheduleDeploy(schedule)) return SCHEDULE_SHAPE.v3
  return SCHEDULE_SHAPE.legacy
}
